<template>
  <div class="text-with-image-middle"
       :class="{title_text: title_with_content}">
    <div
        class="position-relative text-with-image-middle__img-block"
        :class="{fit_to_content: fit_to_content}">
      <shape-head-image-component
        :desktop_src="img_src"
        :desktop_src_lazy="lazy_img_src"
      />
    </div>

    <div class="text-with-image-middle__text-block">
      <default-title
          v-if="title"
          :title="title"
          :title_tag="title_tag"
          class="text-with-image-inline__title"
          :class="inline_title_classes"
      />
      <html-block
          class="text-with-image-middle__text"
          :content="content"
      />
      <div
          v-if="button_text && button_link"
          class="text-with-image-inline__link">
        <default-button
            is_light
            bordered
            :href="button_link">
          {{ button_text }}
        </default-button>
      </div>
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>

import LazyImage from "../../small_parts/LazyImage.vue";
import WaveSmallerIcon from "../../fill_svg/WaveSmallerIcon.vue";
import ArrowRightIcon from "../../icons/ArrowRightIcon.vue";
import ArrowTextHover from "../../small_parts/ArrowTextHover.vue";
import DefaultButton from "../../slots/DefaultButton.vue";
import DefaultTitle from "../../small_parts/DefaultTitle.vue";
import HtmlBlock from "../../small_parts/HtmlBlock.vue";
import ShapeHeadImageComponent from "../ShapeHeadImageComponent.vue";

export default {
  name: "TextWithImageMiddle",
  components: {
    ShapeHeadImageComponent,
    HtmlBlock, DefaultTitle, DefaultButton,
    ArrowTextHover,
    ArrowRightIcon,
    WaveSmallerIcon,
    LazyImage,
  },
  props: {
    img_src: {
      type: String,
      default: '',
    },
    lazy_img_src: {
      type: String,
      default: '',
    },
    img_border_radius: {
      type: Boolean,
      default: false,
    },
    fit_to_content: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    title_tag: {
      type: String,
      default: 'h1',
    },
    content: {
      type: String,
      default: '',
    },
    button_text: {
      type: String,
      default: '',
    },
    button_link: {
      type: String,
      default: '',
    },
    title_with_content: {
      type: Boolean,
      default: false,
    },
    title_on_center: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inline_title_classes() {
      return {
        centered: this.title_on_center
      }
    }
  }
}
</script>
